var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "299px",
    height: "221px",
    viewBox: "0 0 299 221",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trip interface empty copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "10.8818182 41.8908163 122.975934 41.8908163 132.109311 121.670753 0.56944012 121.670753"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "17.4028184 46.581295 116.3163 46.581295 124.375726 116.980275 8.30302562 116.980275"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trip-interface-empty-copy",
    transform: "translate(-1.000000, -40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 40.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.254584,111.741573 C263.589504,172.19705 214.411011,221 153.842324,221 C92.8595457,221 43.4232365,171.527465 43.4232365,110.5 C43.4232365,105.447329 43.7621099,100.473863 44.4183532,95.6011236 L9.93258427,95.6011236 C4.44696945,95.6011236 6.71794063e-16,91.1541541 0,85.6685393 C-6.71794063e-16,80.1829245 4.44696945,75.7359551 9.93258427,75.7359551 L48.9985591,75.7359551 L88.0798639,75.7359551 C93.5654787,75.7359551 98.0124481,71.2889856 98.0124481,65.8033708 C98.0124481,61.5361533 95.3215139,57.8974372 91.543996,56.491573 C90.4654202,56.8929824 89.2982612,57.1123596 88.0798639,57.1123596 L42.1898457,57.1123596 C36.7042309,57.1123596 32.2572614,52.6653901 32.2572614,47.1797753 C32.2572614,41.6941605 36.7042309,37.247191 42.1898457,37.247191 L71.1710885,37.247191 C91.4001989,14.4006708 120.940764,0 153.842324,0 C201.299058,0 241.763324,29.9602512 257.37869,72.011236 L289.067416,72.011236 C294.553031,72.011236 299,76.4582054 299,81.9438202 C299,87.429435 294.553031,91.8764045 289.067416,91.8764045 L262.699818,91.8764045 L240.69607,91.8764045 C235.210455,91.8764045 230.763485,96.3233739 230.763485,101.808989 C230.763485,107.294604 235.210455,111.741573 240.69607,111.741573 L264.254584,111.741573 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(85.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-26"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M11.3213478,42.3908163 L1.13823002,121.170753 L131.548804,121.170753 L122.529909,42.3908163 L11.3213478,42.3908163 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-26-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M17.842348,47.081295 L8.87181552,116.480275 L123.815219,116.480275 L115.870275,47.081295 L17.842348,47.081295 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Path-12",
    stroke: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9590548,83.3710733 C23.3982412,84.6214839 20.2342054,89.2071938 23.4669475,97.1282032 C27.6422892,103.545279 35.3859621,103.545279 46.6979663,97.1282032 C63.6659725,87.5025889 68.0649238,77.1913064 90.0611333,79.880001 C106.212914,79.3606346 112.987425,73.8344407 110.384666,63.3014196 C108.129099,58.3373392 104.237529,56.7008939 98.7099575,58.3920836",
    id: "Path-13",
    stroke: "#EB8181",
    strokeDasharray: "4,4,4,4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-18",
    fill: "#EB8181",
    cx: 67,
    cy: 81.85,
    rx: 6.08396947,
    ry: 3.55
  }), /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(38.000000, 0.000000)",
    fill: "#87D5FA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5060676,8.29245474 C38.1817022,-2.76415158 19.8198932,-2.76415158 8.49393242,8.29245474 C-1.71044073,18.2555505 -2.85915066,37.0150194 5.80084582,48.288147 L29,81 L52.1991542,48.288147 C60.8591507,37.0150194 59.7104407,18.2555505 49.5060676,8.29245474 Z M29.2823912,37.384196 C23.9951347,37.384196 19.7098085,33.2001942 19.7098085,28.0379523 C19.7098085,22.8757103 23.9951347,18.6917086 29.2823912,18.6917086 C34.5696477,18.6917086 38.8549739,22.8757103 38.8549739,28.0379523 C38.8549739,33.2001942 34.5696477,37.384196 29.2823912,37.384196 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    fill: "#EB8181",
    transform: "translate(67.000000, 29.000000) rotate(-315.000000) translate(-67.000000, -29.000000) ",
    cx: 67,
    cy: 29,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(67.000000, 29.000000) scale(1, -1) translate(-67.000000, -29.000000) translate(60.000000, 22.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0.183006536 L7,13.1964203",
    id: "Path-16",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-18",
    points: "0.194444444 7.50326797 6.95540778 13.1121754 13.3804551 7.50326797"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripUpload);
export default __webpack_public_path__ + "static/media/trip-upload.08f5a29a1499e9e29340c7387e5f0aa6.svg";
export { ForwardRef as ReactComponent };